$(document).ready(function () {
   $(".header__search-close").on("click", function () {
     $("#search_results").hide();
   });
  $(".search-desktop-input").on("focus", function () {
    $(this).keyup(function () {
      $(".search-menu-results").show();
      searchProducts(this.value);
    });
  });
});
function searchProductsMobile(search_w) {
  if (search_w.length > 0) {
    $("#search_results_mobile_content")
      .empty()
      .html(
        '<div style="padding: 30px;text-align: center;margin: 0 auto">Loading...</div>'
      )
      .show();

    $.ajax({
      url: "/search",
      data: {
        type: 'product,article',
        view: "json",
        q: search_w,
        options: {
          prefix: "last",
          unavailable_products: "hide",
        },
        sort_by: "relevance",
      },
      success: function (dataHTML) {
        if (dataHTML.length > 10) {
          $("#search_results_mobile_content").html(dataHTML);
        } else {
          clearSearchMobile();
        }
      },
    });
  } else {
    clearSearchMobile();
  }
}
function searchProducts(search_w) {
  if (search_w.length > 0) {
    $("#search_results")
      .empty()
      .html(
        '<div style="padding: 30px;text-align: center;margin: 0 auto">Loading...</div>'
      )
      .show();

    $.ajax({
      url: "/search",
      data: {
        view: "json",
        q: search_w,
        options: {
          prefix: "last",
          unavailable_products: "hide",
        },
        sort_by: "relevance",
      },
      success: function (dataHTML) {
        if (dataHTML.length > 10) {
          $("#search_results").html(dataHTML);
        } else {
          clearSearch();
        }
      },
    });
  } else {
    clearSearch();
  }
}

function clearSearch() {
  $("#search_results").empty().hide();
  $(".search-menu-no-results").show();
}
function clearSearchMobile() {
  $("#search_results_mobile_content").empty();
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('NEWWWW');
  document.querySelector(".header__search-close").addEventListener("click", (() => {
    console.log('close');
    document.querySelector("#shopify-section-header").querySelector(".header__wrapper").classList.add("with__background")
  }));
});